export default function EFCoupon(props) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M13.3763 20.3813L39.1583 9.90199C40.4474 9.37803 41.9162 10.0075 42.4259 11.3022L46 20.3813M22.3737 31.1076H29.1263M22.3737 37.9658H38.1263M52.75 27.2394V22.8813C52.75 21.5006 51.6307 20.3813 50.25 20.3813H10.25C8.86929 20.3813 7.75 21.5006 7.75 22.8813V27.2394C11.1237 27.2394 14.5 29.5246 14.5 34.0975C14.5 38.6705 11.1263 40.9557 7.75 40.9557V45.3138C7.75 46.6945 8.86929 47.8138 10.25 47.8138H50.25C51.6307 47.8138 52.75 46.6945 52.75 45.3138V40.9557C49.3763 40.9557 46 37.5253 46 33.525C46 29.5246 49.3763 27.2394 52.75 27.2394Z"
                stroke="url(#paint0_linear_2302_14531)"
                strokeWidth="2.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <defs>
                <linearGradient id="paint0_linear_2302_14531" x1="7.70924" y1="8.95016" x2="49.527" y2="5.71123" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FF971E" />
                    <stop offset="1" stopColor="#FF4E17" />
                </linearGradient>
            </defs>
        </svg>
    );
}
